<ng-template #templateRef>
  <ng-content></ng-content>
</ng-template>
